
<div class="w-100 white">
    <f-title class="mt-2" :title="title">
        <template v-slot:right>
            <div class="v-flex" style="margin-left: -55px; margin-top: -4px;">
                <c-toolbar-button
                    :icon     = "expand ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'"
                    size     = "21"
                    color    = "primary"
                    :tooltip = "expand ? $t('dms.tree.collapse') : $t('dms.tree.expand')"
                    @click   = "onExpand"
                />
                <!--
                <c-toolbar-button
                    icon     = "mdi-refresh"
                    size     = "21"
                    color    = "primary"
                    :tooltip = "$t('dms.refresh.tooltip')"
                    @click   = "onRefresh"
                />
                -->
            </div>
        </template>
    </f-title>
    <v-text-field
        v-model        = "search"
        clear-icon=    " fas fa-times"
        class          = "mb-3"
        autocomplete   = "off"
        autocorrect    = "off"
        autocapitalize = "off"
        spellcheck     = "false"
        hide-details
        clearable
    ></v-text-field>
    <div>
        <v-treeview
            :open-all     = "expand"
            :items        = "folders"
            item-key      = "id"
            item-text     = "name"
            item-children = "entries"
            ref           = "treeview"
            hoverable
            dense
        >
            <template v-slot:label="{ item, open }">
                <div class="v-flex">
                    <div class="no-frame" style="width: 70%">
                        <div class="v-flex" v-if  = "item.type === 3">
                            <div style = "width: 25px;">
                                <v-icon
                                    size = "21"
                                    color="primary"
                                >
                                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                            </div>

                            <div
                                style="padding-top: 2px; font-size: 15px;"
                                class="primary--text"
                            >
                                {{ item.name }}
                            </div>
                        </div>

                        <c-dms-filename
                            :item     = "item"
                            @document = "onDocument"
                        >
                            <template v-slot:filename="{ item }">
                                <v-tooltip bottom  >
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            v-bind = "attrs"
                                            v-on   = "on"
                                            class  = "v-flex"
                                        >
                                            <div :class="getUnit(item) ? 'unit-doc' : ''">
                                                <span class="primary--text">{{ item.name }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <div v-if = "getUnit(item)">
                                        Anlage {{ getUnit(item) }} zugeordnet
                                    </div>
                                    <div v-if = "!getUnit(item)">
                                        Allen Anlagen zugeordnet
                                    </div>
                                </v-tooltip>
                            </template>
                        </c-dms-filename>
                    </div>
                </div>
            </template>
        </v-treeview>
    </div>
</div>
